import React, { useEffect } from 'react';

import Modal from '../modal';

import './info-modal.scss';

const InfoModal = ({ closeModal }: { closeModal: Function }) => {
  const keyEventListener = (e: KeyboardEvent) => {
    if (e.code === 'Escape') {
      e.preventDefault();
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keyEventListener);

    // componentWillUnmount
    return () => {
      document.removeEventListener('keydown', keyEventListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal>
      <div className='info-modal'>
        <div className='header'>
          <h3>FSC GIS Portal</h3>
          <button className='close esri-icon-close' onClick={() => closeModal()} />
        </div>
        <div className='text'>
          <h4>Terms and Conditions</h4>
          <p>
            Welcome to the FSC GIS Portal.
            <br />
            <br />
            FSC GIS Portal is a computer-based interface, capable of detect, identify, and locate the disturbances and affectations of the forest. It relies on the combination of satellite-derived data, geospatial boundaries of relevant areas, and spatial analysis techniques to calculate and highlight the dynamics of the forest in the certified area using geospatial algorithms based on the contents of selected FSC requirements in FSC Principles and Criteria. It enables access to up-to-date spatial information aiming to improve the FM auditing process and the FM forest certification. It will be only available to authorized and registered users.
          </p>
          <p>The below document lays out the Terms and Conditions for the use of the FSC GIS Portal.</p>
          <p>
            These Terms and Conditions are entered into by you and FSC Group (hereinafter: FSC). Throughout the document FSC and the User each are ‘Party’ and collectively ‘Parties’.
          </p>
          <a
            href='https://fscdatastore.blob.core.windows.net/dev-fscmaps-tc/Terms%20and%20conditions%20for%20GIS%20Platform.pdf'
            rel='noopener noreferrer'
            target='_blank'
          >
            Terms and Conditions
          </a>
          <p><b>Privacy Statement for the use of the GIS Portal</b></p>
          <p>
            Thank you for accepting to use the Service for the GIS Portal, which will provide access to geospatial information and satellite imagery as well as customized tools to identify relevant areas related to forest cover (hereinafter “Service”). We at FSC Global Development GmbH (“FSC GD”) respect your privacy and want you to understand how we collect, use, and share personal data about you in compliance with applicable data protection laws in relation to the use of the Service.
          </p>
          <p>
            The document below covers our data collection practices and describes your rights to access, correct, or restrict our use of your personal data. Except where we provide you a link to a different privacy statement or reference to other privacy documentation, this Privacy Statement applies when you use the Service. By using the Service, you are accepting the practices described in this document.
          </p>
          <a
            href='https://fscdatastore.blob.core.windows.net/dev-fscmaps-tc/FSC%20GD_Privacy%20Statement.pdf'
            rel='noopener noreferrer'
            target='_blank'
          >
            Privacy Statement
          </a>
          <h4>Contact Information</h4>
          <div>
            E-mail: <a href='mailto:maps@fsc.org'>maps@fsc.org</a>
            <br />
            Forest Stewardship Council A.C.
            <br />
            Calle Margarita Maza de Juárez 422, Centro, 68000 Oaxaca, México
            <br />
            Phone: 0052 951 502 6533
            <br />
            Fax: 0052 951 502 6594
            <br />
            Public Registry of Property and Commerce: Oaxaca · Mexico, Registration No. 38602
            <br />
          </div>
          <br />
          <div>
            FSC Global Development GmbH,
            <br />
            Adenauerallee 134, 53113 Bonn (Germany)
            <br />
            Phone: 0049 (0) 228 36766 0<br />
            Fax: 0049 (0) 228 36766 30
            <br />
            Managing Director: Kim Bering Becker Carstensen
            <br />
            Commercial register: Bonn HRB 15990
            <br />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InfoModal;
